"use strict";

import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import { Coder } from "./abstract-coder";
export var BooleanCoder =
/*#__PURE__*/
function (_Coder) {
  _inherits(BooleanCoder, _Coder);

  function BooleanCoder(localName) {
    _classCallCheck(this, BooleanCoder);

    return _possibleConstructorReturn(this, _getPrototypeOf(BooleanCoder).call(this, "bool", "bool", localName, false));
  }

  _createClass(BooleanCoder, [{
    key: "encode",
    value: function encode(writer, value) {
      return writer.writeValue(value ? 1 : 0);
    }
  }, {
    key: "decode",
    value: function decode(reader) {
      return reader.coerce(this.type, !reader.readValue().isZero());
    }
  }]);

  return BooleanCoder;
}(Coder);